import { useInstance } from 'intact-vue';
import { useState } from '../../hooks/useState';
export function useShowImage() {
  var instance = useInstance();
  var isShow = useState(false);
  var image = useState(null);
  function show(file) {
    isShow.set(true);
    image.set(file);
  }
  function close() {
    isShow.set(false);
  }
  return {
    show: show,
    close: close,
    image: image,
    isShow: isShow
  };
}